/* tslint:disable */

/**
 */
export class DataHightChart {
    newProfil?: string;
    ID_EQUIP?: number;
    profilFace?: number;
    minScaleY?: number;
    maxScaleY?: number;
    typeChart?: number;
    profilType?: number;
    checkTop?: number;
    checkLeft?: number;
    checkRight?: number;
    checkButton?: number;
    checkFront?: number;
    checkRear?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/data-hight-chart.ts